import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	win: 9,
	hideUI: 20,
};

const stepThree = {
	animate_latas: {
		ui: steps.dialogThree,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub05.sub5_act3_a03)
		}
	},
	spin: {
		ui: steps.dialogFive,
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub05.sub5_act3_a05)
		}
	},
}

export const Theme6SubtopicFiveActivityThree = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema6.activities.subtema5], 3);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 sub 5 act 3");
			ObserverEmitter.emit(EVENTS.tema6.topic5.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub05.sub5_act3_a01)
	})

	ObserverEmitter.on(EVENTS.tema6.topic5.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 3, 4, 5, 6, 7, 8, 20].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.topic5.initScene, 3);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 3: Uso de Spin by OXXO." />
					<DialogBarNew
						dialog={`Ahora veremos cómo hacer uso de los puntos Spin Premia.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 5. Spin by OXXO"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub05.sub5_act3_a02)
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "show_products");
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Paso 1: El Cliente selecciona "N" cantidad de artículos de la Tienda OXXO..`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "animate_latas");
							setUiToShow(steps.hideUI);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`Paso 2: El Cliente decide usar sus puntos para llevarse los productos sin pagarlos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub05.sub5_act3_a04)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Paso 3: El Cliente entrega su tarjeta azul o morada para ser escaneada.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "spin");
							setUiToShow(steps.hideUI);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={`Paso 4: El POS canjea los puntos Spin Premia del usuario como medio de pago.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "show_monitor_2");
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`Paso 4: El POS canjea los puntos Spin Premia del usuario como medio de pago.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub05.sub5_act3_a06)
							ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "show_ticket");
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`Paso 5: El POS arroja el ticket de venta con información de la tarjeta como los puntos de lealtad, pago, nuevo saldo.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema6.topic5.actScene, "desk");
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}


			{uiToShow === steps.hideUI && (
				<>

				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="Has completado con éxito Spin by OXXO."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: 0,
									subtema: tasksId.tema6.activities.subtema5
								})
							);
							navigator("/home6/tema6/subtema5/activityFour");
						}}
					/>
				</>
			)}
		</>
	)
}